import React from 'react';
import InboxIcon from '../../assets/icons/inbox.svg';
import ReviewIcon from '../../assets/icons/inreview.svg';
import InterviewIcon from '../../assets/icons/interview.svg';
import HiredIcon from '../../assets/icons/hired.svg';
import OfferedIcon from '../../assets/icons/offered.svg';

const CandidateStatistics = ({statistics}) => {
  const stages = [
    {title: 'Inbox', value: statistics?.inbox, icon: InboxIcon},
    {title: 'In Review', value: statistics?.review, icon: ReviewIcon},
    {
      title: 'Interview',
      value: statistics?.interviewed,
      icon: InterviewIcon,
    },
    {title: 'Offered', value: statistics?.offered, icon: HiredIcon},
    {title: 'Hired', value: statistics?.hired, icon: OfferedIcon},
  ];

  return (
    <div className="bg-white">
      <div className="border-b-2 text font-semibold border-gray-200 py-4 px-8">
        Candidate application statistics
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-5">
        {stages.map((item) => (
          <div
            className="mx-auto flex w-60 justify-center gap-5 p-8"
            key={item.title}
          >
            <img src={item.icon} alt="rock" />
            <div className="flex flex-col justify-center">
              <div className="text-base">{item.title}</div>
              <div className="text-xl font-semibold">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CandidateStatistics;
